import React from 'react';
import './Header.scss';
import logo from '../../assets/Home-icon.svg';

export const Header = ({title, setShow}) => {
  return (
    <div className='header'>
      <div className='logo'>
        <a href={'/'}>
          <img src={logo} className='app-logo' alt='logo' />
        </a>
      </div>
      <div className='headline'>{title}</div>
    </div>
  );
};
